module.exports = __webpack_public_path__ + "p6_img2.jpg?1aa35d7fc5d9d4ae669ca6fa4f510114";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p6/p6_img2.jpg
// module id = 127
// module chunks = 0